import React, { useEffect, useState } from 'react';
import Layout from '../components/Layout';
import classes from "./PromoSubscribe.module.css";
import { useTranslation } from 'react-i18next';
import Header from '../components/Header';
import SmallLoader from '../components/Loaders/SmallLoader';
import OTPInput from "react-otp-input";
import { useNavigate, useSearchParams } from 'react-router-dom';
import { FaCheck } from "react-icons/fa";
// import { getPacks } from '../http/http';
import { useDispatch, useSelector } from 'react-redux';
import { confirmSubAPI, SendOtpAPI } from '../http/http';
import { setUserToken } from '../store/slices/userTokenSlice';
import { toast } from 'react-toastify';
import { v4 as uuidv4 } from 'uuid';
import AutoRenewalModal from '../components/AutoRenewalModal';

const PromoSubscribe = () => {
    const { t } = useTranslation();
    const [msisdn, setMsisdn] = useState("");
    const [loading, setLoading] = useState(false);
    const [extRef, setExtRef] = useState(null);
    const [searchParams, setSearchParams] = useSearchParams();

    const [modal, setModal] = useState(false);
    const [autoRenewal, setAutoRenewal] = useState(true);

    const [selectedPack, setSelectedPack] = useState("Daily");

    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        if (searchParams.get("ext_id")) {
            setExtRef(searchParams.get("ext_id"));
        } else {
            setSearchParams({ ext_id: uuidv4() });
        }
    }, [searchParams]);

    const handleFormSubmission = async (e) => {
        e.preventDefault();

        try {
            if (msisdn?.trim().length == 0) {
                return;
            }
            setLoading(true);

            const response = await confirmSubAPI(msisdn, extRef, selectedPack, autoRenewal);
            console.log(response, 'r');

            setLoading(false);

            if (response?.data?.status == 4) {
                navigate("/subscription-processing", {
                    state: {
                        msisdn: msisdn,
                    }
                })
            }

            if (response?.data?.status == 3) {
                navigate("/subscription-processing", {
                    state: {
                        msisdn: msisdn,
                    }
                })
            }
            else {
                toast.error(t("86"));
            }

        } catch (error) {
            setLoading(false);

            if (error?.response?.data?.status == 0) {
                // blacklisted...
                toast.error(t("93"));
            }
            else if (error?.response?.data?.status == 1) {
                // already subscribed , please login...
                toast.error("Subscription Request is Already Submitted for this MSISDN");
            }
            else {
                toast.error(t("86"));
            }

        }
    }

    return (
        <>
            <div className={classes.container}>
                <h1 className={classes.heading}>
                    Welcome to the{" "}
                    <span style={{ color: '#3550dc' }}>Service.</span>{" "}Please Enter the MSISDN, Select Pack and Click on Subscribe button
                </h1>


                <form className={classes.form} onSubmit={handleFormSubmission}
                >
                    <div className={classes.username_field_form}>
                        <div className={classes.country_code}>
                            {/* <img src="/assets/images/niger.png" alt="flag" className={classes.flag} /> */}
                            <p className={classes.country_code_number}>+227</p>
                        </div>
                        <input
                            id="msisdn"
                            name="msisdn"
                            type="number"
                            onWheel={(e) => e.target.blur()}
                            autoFocus placeholder={t("62")} className={classes.input_field_username}
                            onChange={(e) => {
                                setMsisdn(e.target.value)
                            }}
                            value={msisdn}
                        />
                    </div>

                    <div className={classes.packs}>
                        <p className={classes.packs_heading}>{t("63")}</p>

                        <button type='button' className={`${classes.pack_box}`}
                            onClick={() => setSelectedPack("Daily")}
                        >
                            <span className={`${classes.pack_header}`}>{t("100")}</span>
                            {
                                selectedPack === "Daily" ?
                                    <div className={`${classes.checked_radio}`}>
                                        <FaCheck className={classes.checked_icon} />
                                    </div>
                                    : <div className={classes.dummy_radio}>

                                    </div>
                            }
                            <p className={`${classes.pack_price_point}`}>
                                {t("101")}{" "}/{" "}
                                {t("102")}
                            </p>
                        </button>

                        <button type='button' className={`${classes.pack_box} `}
                            onClick={() => setSelectedPack("Weekly")}

                        >
                            <span className={`${classes.pack_header} `}>{t("108")}</span>
                            {
                                selectedPack === "Weekly" ?
                                    <div className={`${classes.checked_radio}`}>
                                        <FaCheck className={classes.checked_icon} />
                                    </div>
                                    : <div className={classes.dummy_radio}>

                                    </div>
                            }
                            <p className={`${classes.pack_price_point}`}>
                                {t("106")}{" "}/{" "}
                                {t("107")}
                            </p>
                        </button>

                        <button type='button' className={`${classes.pack_box}`}
                            onClick={() => setSelectedPack("Monthly")}

                        >
                            <span className={`${classes.pack_header}`}>{t("105")}</span>
                            {
                                selectedPack === "Monthly" ?
                                    <div className={`${classes.checked_radio}`}>
                                        <FaCheck className={classes.checked_icon} />
                                    </div>
                                    : <div className={classes.dummy_radio}>

                                    </div>
                            }
                            <p className={`${classes.pack_price_point} `}>
                                {t("103")}{" "}/{" "}
                                {t("104")}
                            </p>
                        </button>

                    </div>

                    <button type="submit"
                        disabled={loading}
                        className={classes.login_btn}>{
                            loading ? <SmallLoader style={{ border: "5px solid #fff" }} /> : t("61")
                        }</button>
                    <div className={classes.footer}>
                        <p><span>&copy;</span> Rainboo Softmate {new Date().getFullYear()}</p>
                    </div>
                </form>

            </div>

            {modal && <AutoRenewalModal setModal={setModal} />}
        </>
    )
}

export default PromoSubscribe